/** Provides a global toast notification context with show/hide controls. */
import { useState, useCallback } from 'react';
import { TOAST_TIMEOUT_MS } from '@/config/constants';
import { ToastContext } from './ToastContext.def';

const ID_RADIX = 36;
const ID_SUBSTR_END = 9;

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, options = {}) => {
    const id = Math.random().toString(ID_RADIX).substring(2, ID_SUBSTR_END);
    const {
      type = 'info',
      duration = TOAST_TIMEOUT_MS,
      action = null,
    } = options;

    const newToast = { id, message, type, action };
    setToasts((prev) => [...prev, newToast]);

    if (duration !== Infinity) {
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, duration);
    }

    return id;
  }, []);

  const hideToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast, hideToast, toasts }}>
      {children}
    </ToastContext.Provider>
  );
};
